import { render, staticRenderFns } from "./IconClock.vue?vue&type=template&id=77627060&"
import script from "./IconClock.vue?vue&type=script&lang=ts&"
export * from "./IconClock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports